import { render, staticRenderFns } from "./IconActieveKlant.vue?vue&type=template&id=4ef00e68&"
import script from "./IconActieveKlant.vue?vue&type=script&lang=ts&"
export * from "./IconActieveKlant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports